﻿import axios from "axios";
import { modal } from "../utils/antdStatic";
import { store } from "../redux/store";
import { persistor } from "../redux/store";
import { logoutThunk } from "../redux/state/loginstate/user";
import { STORAGE_SESSION_ACTIVE } from "../utils/storageKeys";
import { navigateSPA } from "../utils/navigationRef";

const DEFAULT_HEADERS = {
  Accept: "application/json, text/plain, */*",
  "Content-Type": "application/json",
};

// Evita mostrar el diálogo varias veces si múltiples llamadas devuelven 401
let _sessionExpiredHandled = false;

function createApiClient(baseURL) {
  const client = axios.create({ baseURL, headers: DEFAULT_HEADERS, timeout: 15000 });

  client.interceptors.response.use(
    (response) => {
      // Resetea el flag en cada respuesta exitosa para que futuros 401
      // (tras reautenticación) vuelvan a mostrar el dialog de sesión expirada.
      _sessionExpiredHandled = false;
      return response;
    },
    (error) => {
      const status = error.response?.status;

      const { codigoAfiliado, usuario } = store.getState().user ?? {};
      const isAuthenticated = !!(codigoAfiliado && usuario);

      // Requests que autentican via ?token= (patrón legado) manejan 401 localmente
      const usesLegacyTokenAuth = !!error.config?.params?.token;

      if (status === 401 && !_sessionExpiredHandled && isAuthenticated && !usesLegacyTokenAuth && !error.config?._skipSessionExpired) {
        _sessionExpiredHandled = true;
        localStorage.setItem(STORAGE_SESSION_ACTIVE, "false");
        sessionStorage.removeItem("expiretime");
        store.dispatch(logoutThunk());
        persistor.purge();

        modal.warning({
          title: "Sesión expirada",
          content: "Su sesión ha expirado. Por favor, inicie sesión nuevamente.",
          okText: "Aceptar",
          keyboard: false,
          maskClosable: false,
          onOk: () => {
            _sessionExpiredHandled = false;
            navigateSPA("/?razon=expirada", { replace: true });
          },
        });
      }

      return Promise.reject(error);
    }
  );

  return client;
}

export const apiAfiliado = createApiClient(import.meta.env.VITE_API_URL_AFILIADOS);
export const apiPrestador = createApiClient(import.meta.env.VITE_API_URL_PRESTADORES);
export const apiPromotor = createApiClient(import.meta.env.VITE_API_URL_PROMOTORES);
export const apiUserRol = createApiClient(import.meta.env.VITE_API_URL_ROLES);
export const apiUsers = createApiClient(import.meta.env.VITE_API_URL_USUARIOS);
export const apiRenacer = createApiClient(import.meta.env.VITE_API_URL_APIRENACER);
export const apiCarnetPrint = createApiClient(import.meta.env.VITE_API_URL_APICARNETPRINT);
export const apiRenanWs = createApiClient(import.meta.env.VITE_API_URL_AFILRENANWS);
export const apiResetPass = createApiClient(import.meta.env.VITE_API_URL_RESTABLECER_PASS);
